import { AppStore, RootState } from "./store.ts";
import { envFlag } from "../utilities/env-util.ts";

const DEV_STORE_STATE_KEY = "DEV_STORE_STATE";

export function interceptStateForDev(store: AppStore): void {
  if (envFlag("VITE_ENABLE_MOCKS", import.meta.env) ?? false) {
    sessionStorage.setItem(
      DEV_STORE_STATE_KEY,
      JSON.stringify(store.getState()),
    );
    store.subscribe(() => {
      sessionStorage.setItem(
        DEV_STORE_STATE_KEY,
        JSON.stringify(store.getState()),
      );
    });
  }
}

export default function getAppStoreState(): RootState {
  return JSON.parse(sessionStorage.getItem(DEV_STORE_STATE_KEY) ?? "{}");
}
